<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonFormStyles clueRecord">
            <van-nav-bar
                title="线索记录"
                left-arrow
                left-text="返回"
                @click-left="onClickLeft"
                @click-right="gitClueRecordData"
            >
                <template #right v-if="!isReadOnly">
                    <span class="van-nav-bar__text">保存</span>
                </template>
            </van-nav-bar>
            <section>
                <div class="clueInfo">
                    <van-cell-group>
                        <van-cell
                            title="线索编号"
                            :value="clueRecordData.clue_number"
                            :icon="require('@/assets/images/icons/icon_gy_1.png')"
                        ></van-cell>
                        <van-cell
                            title="客户名称"
                            :value="clueRecordData.client_name"
                            :icon="require('@/assets/images/icons/icon_3.png')"
                        ></van-cell>
                        <van-cell
                            title="工程名称"
                            :value="clueRecordData.engineering_name"
                            :icon="require('@/assets/images/icons/icon_2.png')"
                        ></van-cell>
                        <van-cell
                            title="工程位置"
                            :value="clueRecordData.engineering_location"
                            :icon="require('@/assets/images/icons/icon_gy_2.png')"
                        ></van-cell>
                        <van-cell
                            default-date
                            title="线索跟踪结果"
                            :is-link="!isReadOnly"
                            :icon="require('@/assets/images/icons/my_9.png')"
                            :value="saveData.clue_tracking_results_name"
                            @click="openSelect"
                        >
                        </van-cell>
                        <van-field
                            v-model="saveData.lose_order_reason"
                            label="丢单原因"
                            placeholder="请输入丢单原因"
                            input-align="right"
                            :left-icon="require('@/assets/images/icons/icon_34.png')"
                        ></van-field>
                    </van-cell-group>
                </div>
                <div class="followUp">
                    <van-cell
                        default-date
                        title="记录时间"
                        :is-link="!isReadOnly"
                        :icon="require('@/assets/images/icons/icon_gy_7.png')"
                        :value="saveData.record_time"
                        @click="openCalendar()"
                    >
                    </van-cell>
                    <van-cell
                        :icon="require('@/assets/images/icons/icon_3.png')"
                        title="记录人"
                        :value="record_name"
                        default-date
                    >
                    </van-cell>
                    <van-cell
                        default-date
                        title="跟进阶段"
                        :is-link="!isReadOnly"
                        :icon="require('@/assets/images/icons/icon_41.png')"
                        :value="saveData.project_phase_name"
                        @click="openFollowUpStage()"
                    >
                    </van-cell>
                    <van-field
                        v-model="saveData.track_record"
                        rows="2"
                        autosize
                        type="textarea"
                        maxlength="80"
                        class="iconfont iconbeizhu textarea"
                        placeholder="请在此处输入跟进记录"
                        :disabled="isReadOnly"
                    ></van-field>
                </div>
            </section>
            <!-- 线索跟踪结果 -->
            <van-action-sheet
                v-model="show"
                :actions="cueTrackingData"
                cancel-text="取消"
                @select="confirmSelection"
            ></van-action-sheet>
            <!-- 跟进阶段 -->
            <van-action-sheet
                v-model="isFollowUpStageShow"
                :actions="followUpStageData"
                cancel-text="取消"
                @select="selectionPhase"
            ></van-action-sheet>
            <van-popup
                round
                v-model="isDatetimePicker"
                position="bottom"
                :style="{ height: '265px' }"
            >
                <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    @cancel="closeCalendar"
                    @confirm="onConfirm"
                ></van-datetime-picker>
            </van-popup>
        </div>
    </v-touch>
</template>

<script>

export default {
    // 线索记录
    name: 'clue-record',
    components: {},
    props: {},
    data() {
        return {
            isReadOnly: false,
            // 时间选择控件状态
            isDatetimePicker: false,
            // 时间控件默认取当前系统时间
            currentDate: new Date(),
            // 线索记录基础信息数据
            clueRecordData: {},
            // 记录人
            record_name: this.$takeTokenParameters('Name'),
            // 打开线索记录的父级页面
            parentPage: '',
            // 线索记录保存数据
            saveData: {
                // 线索信息id
                clue_info_id: '',
                // 线索跟踪结果
                clue_tracking_results: '',
                // 线索跟踪结果显示名称
                clue_tracking_results_name: '',
                // 丢单原因
                lose_order_reason: '',
                // 项目阶段
                project_phase: '',
                // 项目阶段显示名称
                project_phase_name: '',
                // 记录时间
                record_time: this.formatDate(),
                // 跟踪记录
                track_record: '',
            },
            // 线索跟踪下拉数据集合
            cueTrackingData: [],
            // 跟踪结果上拉状态
            show: false,
            // 跟进阶段数据
            followUpStageData: [],
            // 跟进阶段上拉状态
            isFollowUpStageShow: false,
        };
    },
    computed: {},
    watch: {},
    created() {
        this.clueRecordData = this.$route.query.data;
        this.saveData.clue_info_id = this.clueRecordData.ciid;
        // 打开线索记录的父级页面路由，返回用
        this.parentPage = this.$route.query.type;
        // 线索详情页面打开线索记录只读
        if (this.parentPage === '/clueDetails') {
            this.isReadOnly = true;
        }
        // 参数里有stage 是选择跟进阶段返回
        if (this.$route.query.saveData) {
            // 跟进阶段保存数据赋值
            this.saveData = this.$route.query.saveData;
        }
        // 有record是编辑
        if (this.$route.query.record) {
            this.saveData = Object.assign(this.saveData, this.$route.query.record);
            this.saveData.lose_order_reason = this.clueRecordData.lose_order_reason;
        }
        // 拉取线索跟踪下拉数据集合
        this.gitCueTrackingData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上级菜单
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ path: this.parentPage, query: { ciid: this.clueRecordData.ciid } });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: this.parentPage, query: { ciid: this.clueRecordData.ciid } });
        },
        // 打开时间控件
        openCalendar() {
            if (this.isReadOnly) {return;}
            this.isDatetimePicker = true;
        },
        // 关闭时间控件
        closeCalendar() {
            this.isDatetimePicker = false;
        },
        // 处理时间对象
        formatDate(date) {
            if (!date) {
                date = new Date();
            }
            const Y = date.getFullYear();
            const M = date.getMonth() + 1;
            const D = date.getDate();
            return Y + '-' + this.add0(M) + '-' + this.add0(D);
        },
        // 时间补0
        add0(m) {
            return m < 10 ? '0' + m : m;
        },
        // 确认时间选择回调
        onConfirm(date) {
            this.isDatetimePicker = false;
            this.saveData.record_time = this.formatDate(date);
        },
        // 拉去线索跟踪下拉数据
        gitCueTrackingData() {
            this.$axios
                .get('/interfaceApi/sale/clue_manager/get_clue_result')
                .then(res => {
                    if (res.length > 0) {
                        res.forEach(item => {
                            this.cueTrackingData.push({
                                name: item.dic_name,
                                id: item.dic_code,
                            });
                            if (this.clueRecordData.clue_tracking_results === item.dic_code) {
                                this.saveData.clue_tracking_results_name = item.dic_name;
                                this.saveData.clue_tracking_results = item.dic_code;
                                this.$forceUpdate();
                            }
                        });
                    }
                }).catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 打开线索跟踪下拉
        openSelect() {
            if (this.isReadOnly) {return;}
            this.show = true;
        },
        // 确认线索跟踪
        confirmSelection(data) {
            this.saveData.clue_tracking_results = data.id;
            this.saveData.clue_tracking_results_name = data.name;
            this.show = false;
        },
        // 打开选择跟进阶段页面
        openFollowUpStage() {
            if (this.isReadOnly) {return;}
            if (this.followUpStageData.length < 1) {
                this.$axios
                    .get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=107&type=1')
                    .then(res => {
                        this.followUpStageData = res;
                        this.isFollowUpStageShow = true;
                    }).catch(error => {
                        this.$dialog({ message: error });
                    });
            } else {
                this.isFollowUpStageShow = true;
            }

        },
        // 确认跟进阶段数据
        selectionPhase(data) {
            this.saveData.project_phase = data.code;
            this.saveData.project_phase_name = data.name;
            this.isFollowUpStageShow = false;
        },
        // 保存线索记录数据
        gitClueRecordData() {
            let postUrl = '';
            let postData = {};
            // 有ctid是修改，没有是新增
            if (this.saveData.ctid) {
                postUrl = '/interfaceApi/sale/clue_manager/modify_cluetrace';
                postData = {
                    id: this.saveData.ctid,
                    clue_info_id: this.saveData.clue_info_id,
                    clue_tracking_results: this.saveData.clue_tracking_results,
                    lose_order_reason: this.saveData.lose_order_reason,
                    project_phase: this.saveData.project_phase,
                    project_phase_name: this.saveData.project_phase_name,
                    record_time: this.saveData.record_time,
                    track_record: this.saveData.track_record,
                };
            } else {
                postUrl = '/interfaceApi/sale/clue_manager/add_cluetrace';
                postData = this.saveData;
            }
            this.$axios
                .post(postUrl, postData)
                .then(() => {
                    this.loading = false;
                    this.$router.isBack = 1;
                    this.$router.push({ path: '/clueDetails', query: { ciid: this.clueRecordData.ciid } });
                }).catch(error => {
                    this.loading = false;
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
    },
};
</script>
<style lang="stylus">
.clueRecord
    height 100%
    section
        height calc(100% - 45rpx)
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
</style>